import { useMutation } from 'react-query';
import { client } from 'utils/api-client';

export default function useLogout() {
  const token = localStorage.getItem('token');
  return useMutation(() => client('logout', { data: { token } }).then((res) => res));
}
